/**
 * FILTER.JS
 */
import Hideable from "../classes/hideable";

export default function InitFilterSection() {
	const filterButtons = document.querySelectorAll(".filter-buttons button[data-filter-type]");
	if (filterButtons.length === 0) return;

	let filterTypes = [];

	filterButtons.forEach((filterButton) => {
		const filterType = filterButton.dataset.filterType;

		// All are visible from the beginning, on the first click they'll become invisible
		filterTypes[filterType] = false;

		filterButton.addEventListener("click", (event) => {
			event.preventDefault();

			if (filterButton.getAttribute("aria-pressed") === "true") {
				filterButton.setAttribute("aria-pressed", "false");
				filterTypes[filterType] = false;
			} else {
				filterButton.setAttribute("aria-pressed", "true");
				filterTypes[filterType] = true;
			}

			const filterName = "filterName" in event.target.dataset ? event.target.dataset.filterName : null;

			reloadPartnerVisibility(filterName, filterTypes);
		});
	});
}

/**
 * Checks whether the filter types are set visible and sets the CSS style
 * accordingly.
 *
 * @param filterName
 * @param filterTypes object with filter type as the key and bool as the value
 */
function reloadPartnerVisibility(filterName, filterTypes) {
	const allInvisible = Object.keys(filterTypes).every((k) => !filterTypes[k]);

	const filterItems = filterName
		? document.querySelectorAll(`.filter-items [data-filter-type][data-filter-name="${filterName}"]`)
		: document.querySelectorAll(`.filter-items [data-filter-type]`);

	filterItems.forEach((filterItem) => {
		const visible = filterItem.dataset.filterType.split(",").some((k) => filterTypes[k]);
		const hideableFilterItem = new Hideable(filterItem, true, 0);

		// Show it if it or none is selected, else hide it
		if (allInvisible || visible) hideableFilterItem.show();
		else hideableFilterItem.hide();
	});

	setTimeout(() => {
		let filterGroups = document.querySelectorAll('.filter-group');
		filterGroups.forEach((filterGroup) => {
			let items = filterGroup.querySelectorAll('[data-filter-type]');
			let anyVisible = items.length > 0 && Array.from(items).filter((s) => {
				let style = window.getComputedStyle(s);
				return style.display !== 'none';
			}).length > 0;

			filterGroup.setAttribute('data-empty', !anyVisible);
		});
	}, 10);
}
